import React from 'react';
import { useTranslation } from 'react-i18next';
import enTexts from './FooterEn.json';
import deTexts from './FooterDe.json';
import styles from './Footer.module.css';

function Footer() {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const texts = currentLang.startsWith('de') ? deTexts : enTexts;

    return (
        <footer className={styles.footer}>
            <p>{texts.copyright}</p>
        </footer>
    );
}

export default Footer;
